import React, { useContext } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useQuery } from "@apollo/client";
import {
  PlaceholderText,
  CustomBootstrapTable,
} from "presentational-components";
import { makeTimeStamp } from "utils/TimeStamps";
import { GET_DATA_ASSETS } from "graphql/data";
import { SHARED, SHARED_DATA_ASSET } from "../constants";
import { CollabContext } from "../../Navigation/CollabContext";
import classnames from "classnames";
import styles from "../MyData/MyData.module.scss";
import { statusFormatter } from "../formatters";

const SharedData = () => {
  const collabContext = useContext(CollabContext);
  const currentCollaborationId = collabContext?.currentCollaborationId;

  const { data, loading, error } = useQuery(GET_DATA_ASSETS, {
    skip: !currentCollaborationId,
    variables: {
      status: [SHARED],
      dataAssetType: SHARED_DATA_ASSET,
      collaborationUuid: currentCollaborationId,
    },
    fetchPolicy: "network-only",
  });

  const formatData = (allData) => {
    if (!Array.isArray(allData)) {
      return [];
    }
    return allData.map(
      ({
        uuid,
        name,
        ownerType,
        owner,
        pointOfContact,
        dateModified,
        status,
      }) => {
        return {
          uuid,
          name,
          ownerType,
          owner,
          pointOfContact,
          dateModified,
          ownerName: owner?.name,
          contactName: pointOfContact
            ? `${pointOfContact?.givenName} ${pointOfContact?.familyName}`
            : "",
          status,
          //This is a hack because the table relies on data field for rerenders but you can't use the same field twice
          ownerType2: ownerType,
        };
      }
    );
  };

  let formattedData = [];

  if (!loading) {
    formattedData = formatData(data?.dataAssets?.dataAssets);
  }

  const textTruncateClass = "text-truncate";

  const columns = [
    {
      dataField: "uuid",
      hidden: true,
    },
    {
      dataField: "name",
      text: "Resource Name",
      classes: classnames(textTruncateClass, styles.name),
      headerClasses: textTruncateClass,
      sort: true,
      multiSelectFilter: true,
      headerStyle: () => {
        return { width: "350px", textAlign: "center" };
      },
    },
    {
      dataField: "ownerName",
      text: "Owner",
      classes: textTruncateClass,
      headerClasses: textTruncateClass,
      sort: true,
      multiSelectFilter: true,
    },
    {
      dataField: "status",
      text: "Status",
      classes: textTruncateClass,
      headerClasses: textTruncateClass,
      formatter: statusFormatter,
      sort: true,
      multiSelectFilter: true,
      headerStyle: () => {
        return { width: "140px", textAlign: "center" };
      },
    },
    {
      dataField: "dateModified",
      text: "Last Updated",
      classes: textTruncateClass,
      headerClasses: textTruncateClass,
      sort: true,
      formatter: (cell) => makeTimeStamp(cell, true),
    },
    {
      dataField: "contactName",
      text: "Contact",
      classes: textTruncateClass,
      headerClasses: textTruncateClass,
      sort: true,
      multiSelectFilter: true,
    },
  ];

  const getTableLoadingMessage = (loading, error) => {
    if (loading) {
      return <PlaceholderText>Loading...</PlaceholderText>;
    } else if (error) {
      return (
        <PlaceholderText>
          Error fetching resources. Please refresh the page to try again.
        </PlaceholderText>
      );
    } else {
      return <PlaceholderText>No data found.</PlaceholderText>;
    }
  };

  return (
    <CustomBootstrapTable
      keyField="uuid"
      data={formattedData}
      columns={columns}
      noDataIndication={getTableLoadingMessage(loading, error)}
    />
  );
};

export default SharedData;
